// Store admins can hide the Kitchen Equipment and FOH Equipment pages
// (Settings.kitchenEquipment / Settings.fohEquipment). Both are on unless
// switched off explicitly, so a store that never touches the setting — or
// settings that haven't loaded yet — keeps both pages.
export type EquipmentArea = 'kitchen' | 'foh'

const SETTINGS_KEY: Record<EquipmentArea, 'kitchenEquipment' | 'fohEquipment'> = {
  kitchen: 'kitchenEquipment',
  foh: 'fohEquipment',
}

export const EQUIPMENT_ROUTES: Record<EquipmentArea, string> = {
  kitchen: '/kitchen/equipment',
  foh: '/foh/equipment',
}

export const isEquipmentPageOn = (settings: any, area: EquipmentArea): boolean =>
  settings?.[SETTINGS_KEY[area]]?.enabled !== false

// True for any route under a switched-off equipment page (tours, checklists, links)
export const isRouteHiddenBySettings = (route: string, settings: any): boolean =>
  (Object.keys(EQUIPMENT_ROUTES) as EquipmentArea[]).some(
    (area) => route.startsWith(EQUIPMENT_ROUTES[area]) && !isEquipmentPageOn(settings, area)
  )
